<template>
  <div class="image-carousel">
    <div
      class="carousel-wrapper"
      :style="{ 'transform': `translateX(${currentOffset}px)` }"
    >
      <div
        v-for="(image, index) in images"
        :key="image"
        class="carousel-item"
      >
        <img :src="image" alt="">
      </div>
    </div>
    <button @click="moveCarousel(-1)">Prev</button>
    <button @click="moveCarousel(1)">Next</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        'image1.jpg',
        'image2.jpg',
        'image3.jpg',
        // ...
      ],
      currentOffset: 0
    };
  },
  methods: {
    moveCarousel(direction) {
      const imageWidth = 300; // 假设每个图片的宽度是300px
      this.currentOffset += direction * imageWidth;

      // 实现无缝滚动
      if (this.currentOffset > 0) {
        this.currentOffset = this.images.length * -imageWidth + this.currentOffset;
      } else if (this.currentOffset < -(this.images.length * imageWidth)) {
        this.currentOffset = 0;
      }
    }
  }
};
</script>

<style scoped>
.carousel-wrapper {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item {
  width: 300px; /* 每个图片的宽度 */
}

img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/NewMessage/NewMessage.vue